import styled from 'styled-components';
import {
  Modal as SemanticModal,
  Dropdown as SemanticDropdown,
  Form as SemanticForm,
  TextArea as SemanticTextArea,
} from 'semantic-ui-react';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent, colors } from '@playbookux/playbook-web-core';

const Modal = styled(SemanticModal)`
  & .ui.selection.dropdown {
    display: flex;
    margin: 20px 0;
  }
`;

const Container = styled.div`
  padding: 20px;
`;

const InviteButton = styled(ButtonLayoutComponent)``;

const CancelButton = styled(ButtonLayoutComponent.Inverted)``;

const ContainerButton = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Text = styled(TextLayoutComponent.Title)``;

const Dropdown = styled(SemanticDropdown)``;

const Form = styled(SemanticForm)`
  margin-botton: 10px;
`;

const Label = styled.label`
  color: ${colors.GRAY_TEXT} !important;
  font-weight: bold;
  margin-bottom: 5px;
`;

const TextArea = styled(SemanticTextArea)`
  margin-botton: 10px;
`;

export {
  Modal,
  Container,
  InviteButton,
  CancelButton,
  ContainerButton,
  Text,
  Dropdown,
  Form,
  TextArea,
  Label,
};
